const SEPARATORS = /[\s\-().\/ ]/g;

const toAsciiDigits = (value: string) =>
  value
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660))
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06f0));

/** The number a campaign can send to, or "" - the same rule the API applies.
 * A number written the local way, with one leading 0, has no country code and
 * can't be sent to.
 */
export const campaignWaIdFromPhone = (phone?: string) => {
  const compact = toAsciiDigits(String(phone || "").replace(SEPARATORS, ""));

  if (!/^\+?\d+$/.test(compact)) {
    return "";
  }

  let digits: string;

  if (compact.startsWith("+")) {
    digits = compact.slice(1);
  } else if (compact.startsWith("00")) {
    digits = compact.slice(2);
  } else if (compact.startsWith("0")) {
    return "";
  } else {
    digits = compact;
  }

  return /^[1-9]\d{7,14}$/.test(digits) ? digits : "";
};
